import Header from "./../../../Headers/HeaderForAreLoggedIn/index.vue"
import Footer from "./../../../Footers/Footer/index.vue"
import ProgressHUD from "./../../../ProgressHUD/index.vue"
import QuestionsAnswersPrivate from "./../../Widget/QuestionsAnswersPrivate/index.vue"
import ReputationShow from "./../../Widget/ReputationData/ReputationShow.vue"
import Api from "./../../../../services/api"

export default {
  name: "ServicesPrivate",
  props: [],
  components: {
    Header,
    Footer,
    ProgressHUD,
    QuestionsAnswersPrivate,
    ReputationShow
  },
  data() {
    return {
      product: {
        _id: "",
        name: "",
        description: "",
        specs: "",
        price: "",
        type: "",
        details: {
          number: "",
          weight: "",
          shipping: "",
          manufacture: "",
          asin: "",
        },
        images: [""],
        available: 0,
        accept: true,
      },
      reviews: [],
      comment: [],
      itemCount: 1,
      validationMessage: null,
      contactMeIsDone: false,
      curentImage: '',     
    }
  },
  methods: {
    minusItem() {
      if (this.itemCount > 1) {
        this.itemCount--
      }
    },
    plusItem() {
      if (this.itemCount < this.product.available) {
        this.itemCount++
      }
    },
    async contactMe() {
      try {
        this.$refs.progress.show()

        var response = await Api.contactMe(this.$route.params.id)

        contactMeIsDone = true
        this.$toast.error({
          title: "Congratulations!",
          message: "Your application will be processed.",
        })
      } catch (error) {
        console.error(error)
        this.$toast.error({
          title: "Error",
          message: error.message,
          color: "#a21010",
        })
      } finally {
        this.$refs.progress.hide()
      }
    },
    goToEditPage: function(product) {
      this.$router.push("/service/edit/" + product._id)
    },
  },
  async created() {
    try {
      var response = await Api.getProductById(this.$route.params.id)

      if (response.data && !response.data.error) {
        this.product = response.data.results.product
        this.reviews = response.data.results.opinion
        this.comment = response.data.results.comment
        this.curentImage = this.product.images[0];
      } else {
        this.validationMessage = "Something went wrong."
        console.error("Something went wrong.")
      }
    } catch (error) {
      console.error(error)
      this.$toast.error({
        title: "Error",
        message: error.message,
        color: "#a21010",
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
  mounted() {
    $(".modal").modal()
    $("select").material_select()
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Services/Private/ServicesPrivate.component.js